import "../css/module.css";  
import ToggleButton from "./ToggleButton";
import { useState, useEffect } from "react";

const ModuleCard = ({ title, description, toggles: initialToggles }) => {
  const [toggles, setToggles] = useState(initialToggles);
  const [hasActiveToggle, setHasActiveToggle] = useState(false);

  useEffect(() => {
    setHasActiveToggle(toggles.some((toggle) => toggle.status));
  }, [toggles]);

  const handleToggle = (label) => {
    setToggles((prevToggles) =>
      prevToggles.map((toggle) =>
        toggle.label === label ? { ...toggle, status: !toggle.status } : toggle
      )
    );
  };

  return (
    <div className={`modulecard ${hasActiveToggle ? "active-module" : ""}`}>
      <span>
        <span className="modulecard-title">{title}</span>
        <p className="modulecard-description">{description}</p>
      </span>
      <span className="module-toggles">
        {toggles.map(({ label, status }, index) => (
          <div key={index} className="toggle-item">
            <ToggleButton 
              label={label} 
              isActive={status} 
              onToggle={() => handleToggle(label)} 
            />
          </div>
        ))}
      </span>
    </div>
  );
};

export default ModuleCard;
